export default "__VITE_ASSET__DsSPAAtj__ 584w";